import React from 'react';
import styled, { keyframes } from 'styled-components';

interface DataLoaderProps {
  text?: string;
}

const pulse = keyframes`
  0%, 80%, 100% {
    background-color: #e9efef;
    transform: scale(1);
  }
  40% {
    background-color: #c7dfdd;
    transform: scale(1.2);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const IndicatorsWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const Indicator = styled.div<{ $delay: number }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #e9efef;
  animation: ${pulse} 1.5s infinite;
  animation-delay: ${props => props.$delay}s;
`;

const LoaderText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  text-align: center;
`;

const DataLoader: React.FC<DataLoaderProps> = ({ text = '데이터 준비중입니다' }) => {
  return (
    <Container>
      <IndicatorsWrapper>
        <Indicator $delay={0} />
        <Indicator $delay={0.5} />
        <Indicator $delay={1} />
      </IndicatorsWrapper>
      <LoaderText>{text}</LoaderText>
    </Container>
  );
};

export default DataLoader;
